export default "__VITE_ASSET__0t7xv0fA__"